module.exports = __webpack_public_path__ + "img/no-data-recruiters.03d9b38f.svg";